import pgrid from 'projection-grid';
import _ from 'underscore';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { toolbarPlugin } from '@bingads-webui/projection-grid-toolbar';
import { inlineDownloadWithoutFilterstatePlugin } from '@bingads-webui-campaign/projection-grid-inline-download';
import { columnChooserPlugin } from '@bingads-webui-campaign/projection-grid-column-chooser';
import { dateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';
import { segmentPlugin } from '@bingads-webui-campaign/projection-grid-segment';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { merge } from '@bingads-webui-universal/primitive-utilities';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import { pillControlPlugin } from './projection-grid-pill-control';
import { chartPlugin } from './projection-grid-chart';
import { getConfig } from './general-insights-grid-config';

const preferencesService = globalContext.requireDefault('component/preference/service/index');
const { newPerformanceLogPlugin } = globalContext.require('component/bingads-grid/plugin/new-performance-log');

export class GeneralInsightsGrid extends DeterministicWrapperView {
  viewFactory({
    scope,
    addDateChangeListener,
    container,
    filterService,
    preferenceConfig,
    currentScenario,
    currentActivity,
    toggleChartToolbar,
    campaignType,
    onCampaignTypeSelectChange,
    showCampaignTypeDropdown,
    featureName,
    showAlertHandler,
  }) {
    const gridPlugins = pgrid.factory({ vnext: true })
      .use(dateFilterPlugin)
      .use(toolbarPlugin)
      .use(columnChooserPlugin)
      .use(uiBlockerPlugin)
      .use(placeholderPlugin)
      .use(segmentPlugin)
      .use(inlineDownloadWithoutFilterstatePlugin)
      .use(pillControlPlugin)
      .use(chartPlugin)
      .use(newPerformanceLogPlugin);

    let config = getConfig({
      scope,
      view: this,
      addDateChangeListener,
      container,
      filterService,
      currentScenario,
      currentActivity,
      toggleChartToolbar,
      campaignType,
      onCampaignTypeSelectChange,
      showCampaignTypeDropdown,
      featureName,
      showAlertHandler,
    });

    config = merge(config, preferenceConfig);

    this.grid = gridPlugins
      .create(config);

    this.grid.gridView.on('willUpdate', (changes) => {
      if (_.has(changes, 'sortableHeader')) {
        const orderby = _.result(changes.query, 'orderby') || _.result(this.grid.gridView.get('query'), 'orderby');
        const { sortableHeader } = changes;

        preferencesService.setAtUserLevel({
          Name: `WebApp.CampaignUI.${config.name}`,
          Data: { sortInfo: { orderby, sortableHeader } },
        });
      }
    });

    return this.grid.gridView;
  }

  getUpperToolbar() {
    return this.grid.toolbar.gridToolbarGroup.toolbarWithName('upper-toolbar');
  }

  hideLowerToolbar() {
    this.grid.toolbar.gridToolbarGroup.toolbarWithName('lower-toolbar').hide();
  }

  showLowerToolbar() {
    this.grid.toolbar.gridToolbarGroup.toolbarWithName('lower-toolbar').show();
  }

  remove() {
    this.grid.toolbar.gridToolbarGroup.remove();
    this.grid.toolbar = null;
    super.remove();
  }

  refresh() {
    this.grid.gridView.refresh(true);
  }

  get className() { return 'general-insights-grid'; }
}
